<template functional>
    <div class="group-header">
        <div class="group-header__details">
            <component
                v-if="props.flagCode"
                :is="props.components.FlagIcon"
                :flag="`flags/${props.flagCode}.png`"
            />
            <span
                :title="props.title"
                class="group-header__details-title"
            >
                {{ props.title }}
            </span>
        </div>
        <i
            v-if="props.isFavouritable"
            @click="() => listeners.favouriteClick(props.id)"
            class="icon group-header__action-icon"
            :class="props.isFavourite ? 'icon-favourite_filled' : 'icon-favourite'"
        >
        </i>
    </div>
</template>

<script>
    import FlagIcon from '@modules/shared/components/FlagIcon';

    export default {
        functional: true,
        name: 'SectionHeaderRow',
        props: {
            id: {
                type: String,
                required: true,
            },
            flagCode: {
                type: String,
                required: false,
            },
            title: {
                type: String,
                required: true,
            },
            isFavouritable: {
                type: Boolean,
                required: true,
            },
            isFavourite: {
                type: Boolean,
                default: false,
            },
            components: {
                type: Object,
                default() {
                    return {
                        FlagIcon,
                    };
                }
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/eventGrid/components/SectionHeaderRow.vue